export default {
    add_all_materials_from_warehouse: "Добавить все материалы со склада",
    add_good: "Добавить товар",
    add_material: "Добавить материал",
    add_new: "Добавить новый",
    adding_new_supplier: "Добавление нового поставщика",
    addition: "Приход",
    address: "Адрес",
    adjustment: "Корректировка",
    amount: "Кол-во",
    amount_of_stock_on_all_warehouses: "Общее количество товара, доступное на всех складах клиники",
    approve: "Провести",
    approved: "Проведен",
    are_you_sure_you_want_to_delete_group: "Вы уверены, что хотите удалить группу?",
    are_you_sure_you_want_to_delete_kit: "Вы уверены, что хотите удалить комплект?",
    are_you_sure_you_want_to_delete_supplier: "Вы уверены, что хотите удалить поставщика?",
    are_you_sure_you_want_to_delete_warehouse: "Вы уверены, что хотите удалить склад?",
    artikul: "Артикул",
    available_for_sale: "Доступен для продажи",
    bank_requisites: "Банковские реквизиты",
    barcode: "Штрихкод",
    beginning_balance: "Начальный остаток",
    bin: "БИН",
    branch: "Филиал",
    bulk_addition: "Добавить группой",
    by_categories: "По категориям",
    consumption: "Расход",
    consumption_manual: "Ручной расход",
    contact_person: "Контактное лицо",
    contragent: "Контрагент",
    cost: "Стоимость",
    created: "Создан",
    current_stock: "Текущий остаток",
    default_for_sale: "Использовать по умолчанию для продажи товаров",
    default_for_writeoff: "Использовать по умолчанию для списания материалов",
    destination: "Назначение",
    details: "Детали",
    difference: "Расхождение",
    documents: "Документы",
    draft: "Черновик",
    enter_title_or_barcode: "Введите наименование или штрихкод",
    factual_amount: "Кол-во по факту",
    finished: "Проведен",
    finished2: "Завершен",
    found_similar_material: "Найден похожий материал",
    from: "от",
    from_warehouse: "Перемещение со склада",
    from_where: "Откуда",
    general_price: "Общая сумма",
    general_stock: "Общий остаток",
    group: "Группа",
    groups: "Группы",
    id: "Id",
    in_warehouse: "На складе",
    inventarization: "Инвентаризация",
    kit: "Комплект",
    Kit: "Комплект",
    kits: "Комплекты",
    material: "Материал",
    materialgroup: "Группа",
    materials: "Материалы",
    materialstock: "Материал",
    movement: "Перемещение",
    movement_from: "Перемещение",
    movement_to: "Перемещение",
    movements: "Движения",
    nomenclature: "Номенклатура",
    not_enough_material: "Не хватает материала",
    notify_when_stock: "Уведомлять при остатке",
    on_visit_close: "При закрытии визита",
    on_visit_save: "При сохранении визита",
    operation: "Операция",
    parent_category: "Родительская категория",
    parent_group: "Родительская группа",
    physical: "Физический",
    price_will_be_used_automatically_from_addition: "Цена будет применена автоматически из документа прихода",
    print: "Распечатать",
    prohibit_minus_stocks: "Запретить списывать в минус материалы",
    prohibit_minus_stocks_in_warehouse_documents: "Данная настройка запрещает списывать материалы в минус при заполнении документов в разделе 'Склад'",
    prohibit_minus_stocks_on_visit_closing: "Запретить списывать в минус материалы визита (запрет на завершение визита)",
    purchase_price: "Цена покупки",
    return: "Возврат",
    returns: "Возвраты",
    sale_of_goods_refund: "Возврат продажи товаров",
    sale_price: "Цена продажи",
    stocks: "Остатки",
    stocks_archive: "Архив материалов",
    supplier: "Поставщик",
    suppliers: "Поставщики",
    to_warehouse: "Перемещение на склад",
    to_where: "Куда",
    trying_to_writeoff: "Попытка списать",
    type: "Тип",
    unit_of_measure: "Ед./изм.",
    virtual: "Виртуальный",
    warehouse_amount: "Кол-во на складе",
    warehouseoperation: "Операции",
    warehouses: "Склады",
    write_off: "Списание",
    write_off_materials: "Списывать материалы"
}
